import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fullscreen-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fullscreen-overlay.component.html',
  styleUrl: './fullscreen-overlay.component.scss',
})
export class FullscreenOverlayComponent {
  @Input() isOverlayLoading!: boolean;
}
